
import React, { useState, useEffect } from 'react'

import store from '@/core/store'

import './HistorySection.scoped.sass'
import threadsService from '@/app-domains/threads/threads.service'
import MemoizedThread from '../FeedContent/Thread/Thread'
import SearchingComponent from '../FeedContent/SearchingComponent'

export function HistorySection () {
  const [currentThread, setCurrentThread] = useState(undefined)
  const [isSearching, setIsSearching] = useState(false)

  function reopenHistoryMenu () {
    store.commit('SIDE_MENU:SHOW')
  }

  useEffect(() => {
    store.on('HISTORY_VIEW:SHOW_THREAD', async (threadId) => {
      let thread = threadsService.getThreadById(threadId)
      if (!thread) {
        setIsSearching(true)
        // STORE MESSAGE AFTER QUERYING
        thread = await threadsService.queryThreadById(threadId)
        setIsSearching(false)
      }
      setCurrentThread(thread)
    })
  }, [])

  return (
    <>
      <div className="back-to-history" onClick={reopenHistoryMenu}><a>Back to history section</a></div>
      <section className="history-feed">
        {currentThread && !isSearching && <div className="post-card-container">
          <MemoizedThread thread={currentThread} />
          </div>}
        {isSearching && <SearchingComponent/>}
      </section>
    </>
  )
}
